import React, { useEffect, useState } from 'react'
import { LangRelevantCourses } from '../../Services/courseService';
import CourseTemplate from './CourseTemplate';
import ClipLoader from 'react-spinners/ClipLoader';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const LanguageRelevantCourses = () => {
  const language = useSelector(store => store.LanguageSlice.language) || { code: 'en', name: 'english' };
  const languageName = language.name.includes('(') ?
    language.name.split('(')[1].replace(')', '').trim().toLowerCase() :
    language.name.toLowerCase();

  const [courses, setCourses] = useState([]);
  //const [showAllCourses, setShowAllCourses] = useState(false);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  const [message, setMessage] = useState();

  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true);
      try {
        const response = await LangRelevantCourses(languageName);
        setCourses(Array.isArray(response?.data) ? response?.data : []);
        setMessage(response?.data?.message);

      } catch (error) {
        console.log('Error fetching language courses. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, [languageName]);

  return (
    <div> 
      {
        courses?.length > 0 ?
          (
            loading ? (<ClipLoader color="#333333" loading={loading} size={30} id='clipLoader' />) :
              <CourseTemplate coursesData={courses} pageTitle={t(`${"languageCourse"}`)} />
          )
          :
          <div className='ES-Empty-Container'>
            <h2 className='ES-Heading'>{message}</h2>
          </div>

      }
    </div>
  )
}
export default LanguageRelevantCourses